import { ISelectOption } from 'components/forms/Selects'
import { SortField } from '../types/carrierMatches'

export interface ISelectOptionDefault extends ISelectOption {
  default?: boolean
}

export const sortByOptions = [
  {
    label: 'Best Match',
    value: SortField.bestMatch,
    default: true,
  },
  {
    label: 'Last Rate',
    value: SortField.lastRate,
  },
  {
    label: 'Last Ran',
    value: SortField.lastRan,
  },
]

export const filterMileOptions = [
  {
    label: 'Exact',
    value: '0',
  },
  {
    label: '10 mi',
    value: '10',
  },
  {
    label: '25 mi',
    value: '25',
  },
  {
    label: '50 mi',
    value: '50',
    default: true,
  },
  {
    label: '75 mi',
    value: '75',
  },
  {
    label: '100 mi',
    value: '100',
  },
  {
    label: '150 mi',
    value: '150',
  },
  {
    label: '200 mi',
    value: '200',
  },
]

export const defaultSelection = (option: ISelectOptionDefault) => option.default
